import { createOrgSchema, setActiveOrgSchema } from "@io-spoke/contracts/orgs";
import type { OrgMembership, OrgSummary } from "@io-spoke/contracts/orgs";
import { getApiClient } from "./apiClient";

export type OrgWithMembership = {
  org: OrgSummary;
  membership: OrgMembership;
};

export async function listOrgs() {
  const api = getApiClient();
  const response = await api.get<{ orgs: OrgWithMembership[] }>("/orgs");
  return response.data.orgs;
}

export async function getCurrentOrg() {
  const api = getApiClient();
  const response = await api.get<{
    org: OrgSummary | null;
    membership: OrgMembership | null;
  }>("/orgs/current");
  return response.data;
}

export async function setActiveOrg(payload: { orgId: string }) {
  const parsed = setActiveOrgSchema.safeParse(payload);
  if (!parsed.success) {
    throw new Error(parsed.error.issues[0]?.message ?? "Invalid active org payload.");
  }
  const api = getApiClient();
  const response = await api.post<{ org: OrgSummary; membership: OrgMembership }>(
    "/orgs/active",
    parsed.data
  );
  return response.data;
}

export async function createOrg(payload: { name: string }) {
  const parsed = createOrgSchema.safeParse(payload);
  if (!parsed.success) {
    throw new Error(parsed.error.issues[0]?.message ?? "Invalid org payload.");
  }
  const api = getApiClient();
  const response = await api.post<{ org: OrgWithMembership }>("/orgs", parsed.data);
  return response.data.org;
}
